// extracted by mini-css-extract-plugin
export default {"parentContainer":"chatBubble_parentContainer__i+-m8","container":"chatBubble_container__sICEB","primary":"chatBubble_primary__U1oN0","secondary":"chatBubble_secondary__o9Prx"};